// 升级路径
import update_sql1 from './update_sql1';
import update_sql2 from './update_sql2';
import update_sql3 from './update_sql3';
import update_sql4 from './update_sql4';
import update_sql5 from './update_sql5';
import update_sql6 from './update_sql6';
import update_sql7 from './update_sql7';
import {
    update_sql10,
    update_sql11,
    update_sql8,
    update_sql9,
} from './update_sql8';
import {
    update_sql12,
    update_sql13,
    update_sql14,
    update_sql15,
    update_sql16,
    update_sql17,
    update_sql18,
    update_sql19,
    update_sql20,
    update_sql21,
} from './update_sql9';

const update_paths = [
    [4, update_sql1], // 从第0版本到第1版本需要执行的sql
    [5, update_sql2], // 从第1版本到第2版本需要执行的sql
    [6, update_sql3], // 从第2版本到第3版本需要执行的sql
    [7, update_sql4], // 从第2版本到第3版本需要执行的sql
    [8, update_sql5], //
    [9, update_sql6], // 群成员
    [10, update_sql7], // 给会话创建索引
    [11, update_sql8], // 创建用户关联表
    [12, update_sql9], // 创建用户关联表
    [13, update_sql10], // 群增加字段
    [14, update_sql11], // 群增加字段
    [15, update_sql12], // 群增加字段
    [16, update_sql13], // 创建群发送消息记录表
    [17, update_sql14], // 创建用户设备表
    [18, update_sql15], // 群增加字段
    [19, update_sql16], // group 增加 group_member_doc
    [20, update_sql17], // 会话增加 msg_synced 字段
    [21, update_sql18], // t_msg 添加 (tid, stime) 复合索引，加速按时间排序的消息查询
    [22, update_sql19], // 版本 22：列由 repair_legacy_schema 幂等补齐
    [23, update_sql20], // 版本 23：列由 repair_legacy_schema 幂等补齐
    [24, update_sql21], // 版本 24：列由 repair_legacy_schema 幂等补齐
];

export {update_paths};
